import {proceduresConstants} from '../constants';
import {proceduresService} from "../services";

export const proceduresActions = {
  getProcedures,
};

function getProcedures(filter, cancelToken) {
  return dispatch => {
    dispatch(request());

    return proceduresService.getProcedures(filter, cancelToken)
      .then(procedures => {
        dispatch(success(procedures));
        return procedures;
      }, error => dispatch(failure(error)));
  };

  function request() {
    return {type: proceduresConstants.GETPROCEDRURES_REQUEST}
  }

  function success(data) {
    return {type: proceduresConstants.GETPROCEDRURES_SUCCESS, data}
  }

  function failure(error) {
    return {type: proceduresConstants.GETPROCEDRURES_FAILURE, error}
  }
}
